<div class="accessibility-wrapper {{#if hide}}see-through{{/if}}" aria-label="{{t 'videoAccessibility.playerInstructions1'}} {{t 'PageHeader'}}. {{t 'videoAccessibility.playerInstructions2'}}" tabindex="0">
  <div id="{{cid}}-video-container"></div>
  <div id="startContainer" class="video-start-container">
    <button id="{{cid}}-startButton" aria-label="{{t 'play'}}">
      {{>icon uuid=cid prefix="fas" name="fa-play" size="fa-lg"}}
    </button>

  </div>
</div>


{{#if transcript}}
    {{#unless transcript.in_controlbar}}
    <div class="transcript">
      <button
        class="{{#if transcript.launch_button.class}}{{transcript.launch_button.class}}{{else}}btn btn-default{{/if}}"
        data-toggle="modal" data-target="#{{transcript.id}}">
          {{t transcript.launch_button.text}}
      </button>
      <div class="transcript-modal"></div>
    </div>
  {{/unless}}
{{/if}}

{{#if keyboard_shortcuts}}
  <div class="keyboard_shortcuts">
    <button class="{{#if keyboard_shortcuts.launch_button_class}}{{keyboard_shortcuts.launch_button_class}}{{else}}btn btn-default{{/if}}" data-toggle="modal" data-target="#{{video_id}}_keyboard_shortcuts">{{t 'videoAccessibility.keyboardShortcutsButton'}}</button>
    <div class="keyboard_shortcuts-modal"></div>
  </div>
{{/if}}
